import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid, IconButton, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { TFunction } from 'i18next';
import React, { FC } from 'react';

import { ContactsDisplayMode } from '../../hooks/use-contacts-variant';

const useStyles = makeStyles((theme: any) => ({
  title: {
    marginRight: theme.spacing(4),
    color: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: { fontSize: theme.typography.h5.fontSize },
  },
  displayButton: {
    fontSize: '1rem',
    padding: theme.spacing(1),
    borderRadius: theme.spacing(0.5),
    color: theme.palette.text.primary,
    '@media (hover: none) and (pointer: coarse)': {
      minWidth: theme.spacing(5.5),
      minHeight: theme.spacing(5.5),
    },
  },
  displayButtonActive: {
    backgroundColor: theme.palette.button.default,
    color: theme.palette.common.black,
  },
  spacing: { marginRight: theme.spacing(1) },
}));

type HeaderProps = {
  t: TFunction;
  displayMode: ContactsDisplayMode;
  canToggleDisplayMode: boolean;
  handleDisplayMode: (mode: ContactsDisplayMode) => void;
};

const Header: FC<HeaderProps> = ({
  t,
  displayMode,
  canToggleDisplayMode,
  handleDisplayMode,
}) => {
  const classes = useStyles();

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Grid item>
        <Grid container direction="row" alignItems="center">
          <Grid item>
            <Typography variant="h4" component="h1" className={classes.title}>
              {t('users:contacts')}
            </Typography>
          </Grid>

          {canToggleDisplayMode && (
            <>
              <Grid item className={classes.spacing}>
                <IconButton
                  aria-label={t('contact:grid-view')}
                  aria-pressed={displayMode === 'grid'}
                  className={clsx(classes.displayButton, { [classes.displayButtonActive]: displayMode === 'grid', })}
                  onClick={() => handleDisplayMode('grid')}
                  size="large"
                >
                  <FontAwesomeIcon icon="grip-horizontal" />
                </IconButton>
              </Grid>

              <Grid item>
                <IconButton
                  aria-label={t('contact:list-view')}
                  aria-pressed={displayMode === 'list'}
                  className={clsx(classes.displayButton, { [classes.displayButtonActive]: displayMode === 'list', })}
                  onClick={() => handleDisplayMode('list')}
                  size="large"
                >
                  <FontAwesomeIcon icon="list" />
                </IconButton>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Header;
